// extracted by mini-css-extract-plugin
export var addFavoriteContainer = "j2TCg";
export var starIcon = "RxV7G";
export var starIconFull = "CarkW";
export var starIconMedium = "o6yPg";